import React from "react";
import { useParams, Link } from "react-router-dom";
import Transcript from "./sublist/transcript";
// import PageNotes from "../../pages/common/pagenotes";
import { useAuth } from "../../../usercontext";
import Student911TopMenu from "../studentInfo/student911topmenu"
import PageNotes from "../../pages/common/pagenotesnew";

export default function InstructorStudentTranskript() {
  let { slug } = useParams();
  const { profile, setProfile } = useAuth();

  return (
    <>
      <Student911TopMenu slug={slug} activeMenu={"Transkript"} />
      <PageNotes
        type={"Instructor"}
        pageName={"StudentTranscriptPlanning"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <Transcript slug={slug} />
            <div className="update-profile">
              <Link
                to={`/instructor/instructor-studenttranskript-edit/${slug}`}
                className="btn btn-primary"
              >
                Update Transcript Planning
              </Link>
            </div>
            {/* <PageNotes
              type={"Instructor"}
              pageName={"StudentTranscriptPlanning"}
              studentId={slug}
              instructorId={profile.id}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
}
